import type { PreviewContinuationOption } from "../api/runs";

const CHANNEL_PREFIX = "ato-session-continuation:";
const SAFE_CHANNEL_ID = /^[A-Za-z0-9_-]{16,128}$/;

export function createContinuationChannelId(): string {
  const browserCrypto = globalThis.crypto;
  if (browserCrypto && typeof browserCrypto.randomUUID === "function") {
    return browserCrypto.randomUUID().replace(/-/g, "");
  }
  const bytes = new Uint8Array(18);
  if (browserCrypto && typeof browserCrypto.getRandomValues === "function") {
    browserCrypto.getRandomValues(bytes);
    return Array.from(bytes, (value) =>
      value.toString(16).padStart(2, "0"),
    ).join("");
  }
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
}
export function continuationChannelName(channelId: string): string | null {
  return SAFE_CHANNEL_ID.test(channelId)
    ? `${CHANNEL_PREFIX}${channelId}`
    : null;
}

export function continuationCallbackUrl(
  channelId: string,
  option: PreviewContinuationOption,
): string {
  const params = new URLSearchParams({
    continuation_channel: channelId,
    continuation_option: option,
  });
  return `/continuation/callback#${params.toString()}`;
}

export function postContinuationCallback(
  channelId: string,
  option: PreviewContinuationOption,
): boolean {
  const name = continuationChannelName(channelId);
  if (!name || typeof BroadcastChannel === "undefined") return false;
  try {
    const channel = new BroadcastChannel(name);
    channel.postMessage({ type: "continuation-complete", option });
    channel.close();
    return true;
  } catch {
    // The original game tab polls the API, so a disabled/partitioned channel
    // is only a lost acceleration hint and must not break the callback page.
    return false;
  }
}

export function continuationCallbackParams(hash = window.location.hash): {
  channelId: string;
  option: PreviewContinuationOption;
} | null {
  const params = new URLSearchParams(
    hash.startsWith("#") ? hash.slice(1) : hash,
  );
  const channelId = params.get("continuation_channel") ?? "";
  const option = params.get("continuation_option");
  if (
    !continuationChannelName(channelId) ||
    (option !== "sign_in" && option !== "cloud_subscription")
  ) {
    return null;
  }
  return { channelId, option };
}
